import { render, staticRenderFns } from "./MainBoard.vue?vue&type=template&id=84317d64&"
import script from "./MainBoard.vue?vue&type=script&lang=js&"
export * from "./MainBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports